import { configureStore } from '@reduxjs/toolkit';
import reservationReducer from '../Redux/Slices/agentAuthSlice';
import voucherReducer from "./Slices/reservationVoucherSlice";
import businessSourceReportReducer from "./Slices/BusinessSourceReportSlice";
import marketSegmentReportReducer from "./Slices/MarketSegmentReportSlice";
import termsReducer from "./Slices/termsSlice";
import connectivityReducer from "./Slices/connectivitySlice";
import voucherOffersReducer from "./Slices/voucherOffersSlice";
import agentReportReducer from "./Slices/reservationAgentReportSlice";
import companyReportReducer from "./Slices/reservationCompanyReportSlice";
import pmsReducer from "./Slices/reserPmsSlice";
import inventoryReducer from "./Slices/reseinventorySlice";

export const store = configureStore({
  reducer: {
    reservation: reservationReducer,
    voucher: voucherReducer,
    businessSourceReport: businessSourceReportReducer,
    marketSegmentReport: marketSegmentReportReducer,
     terms: termsReducer,
     connectivity: connectivityReducer,
     voucherOffers: voucherOffersReducer,
     agentProduReport: agentReportReducer,
     companyProduReport: companyReportReducer,
     pms: pmsReducer,
     inventory: inventoryReducer,
  },
});
